/**
 * Function to toggle full screen mode on the current page.
 * @returns {Promise<void>} - A promise that resolves when the full screen mode is toggled.
 */
export const RFullScreen = async (): Promise<void> => {
  // Only execute if document exists
  if (document) {
    // Determine the element to apply full screen mode to
    let element = document.body;
    if (event instanceof HTMLElement) {
      element = event;
    }

    // Determine if full screen mode is currently active
    let isFullscreen =
      document.webkitIsFullScreen || document.mozFullScreen || false;

    // Define the function to request full screen mode
    element.requestFullScreen =
      element.requestFullScreen ||
      element.webkitRequestFullScreen ||
      element.mozRequestFullScreen ||
      function () {
        return false;
      };

    // Define the function to cancel full screen mode
    document.cancelFullScreen =
      document.cancelFullScreen ||
      document.webkitCancelFullScreen ||
      document.mozCancelFullScreen ||
      function () {
        return false;
      };

    // Toggle full screen mode based on current state
    isFullscreen ? document.cancelFullScreen() : element.requestFullScreen();
  }
};
